module.exports = __webpack_public_path__ + "img/news3.4f6c29e9.png";